import { useMutation, useQuery } from 'react-query'
import request from '../request'

export const useTwoFactorSmsGenerateToken = () => {
  return useMutation(({ phone_number }: { phone_number?: string }) =>
    request({
      url: `/auth/two-factor/sms/generate-token`,
      method: 'POST',
      data: {
        phone_number,
      },
    }),
  )
}
